<template>
 <div class='employee-reports-of-sickness mb-5' v-if="reportsOfSickness.length > 0">
    <h6 style='position: relative; top: -3px; margin-bottom: 13px; left: 2px;'>Verzuimen</h6>
    <div class='report-of-sickness' v-for="report in reportsOfSickness" :key="'ros-summary-employee-'+report.id" @click="handleSelectReportOfSickness(report)">

      <table width='100%' >
        <tr>
          <td>
            <p class='value' style='font-weight: 600; padding-top: 2px; margin-bottom: -3px;'>vanaf {{ formatDate(report.firstOfAbsence) }} </p>
            <p class='value'>t/m {{ report.recoveryDate ? formatDate(report.recoveryDate) : 'onbepaald' }}</p>
          </td>
          <td align='right'>
            <report-of-sickness-disability-rate-graph
              :reportOfSickness="report"
              :width="180" :height="36"
              style='position: relative; top: 2px;' />
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Helpers from '@/shared/helpers/functions';
import ReportOfSicknessDisabilityRateGraph from '@/views/components/reports-of-sickness/ReportOfSicknessDisabilityRateGraph.vue';

import ReportsOfSickness from '@/views/constants/reports-of-sickness';
import AppNavigation from '@/views/constants/app-navigation';

export default {
  name: 'EmployeeReportsOfSickness',
  components: {
    ReportOfSicknessDisabilityRateGraph
  },
  props: {
    employee: Object
  },
  data () {
    return {
      newReportOfSicknessLink: {
        text: 'Nieuw Verzuim Indienen',
        onClick: null
      }
    };
  },

  computed: {
    reportsOfSickness () {
      let rs = this.$store.getters.reportsOfSickness[this.employee.id];
      if (rs) return rs.reverse();
      else return [];
    }
  },

  methods: {
    formatDate: (date) => Helpers.Dates.formatDate(date),
    handleSelectReportOfSickness (report) {
      this.$store.dispatch(AppNavigation.Actions.Navigate.DO, AppNavigation.Views.ReportsOfSickness)
        .then(this.$store.dispatch(ReportsOfSickness.Actions.Tabs.OPEN_DETAILS, {
          reportOfSickness: report,
          employee: this.employee
        })
        );
    }
  }

};
</script>

<style lang='scss' scoped>
  @import '@/assets/stylesheets/variables.scss';

  .employee-reports-of-sickness {
    width: 100%;
    background-color: $gray-lighten-2;
    display: block;
    right: 0px;
    padding: 20px 20px 1px 20px;
    border-radius: $border-radius;

    .report-of-sickness {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      border-radius: $border-radius;
      display: block;
      margin-bottom: 20px;

      background: white;
      padding: 15px 20px;
      transition: $base-transition;

      box-shadow: 0px 1px 3px rgba(42, 35, 102, 0.2), 0px 2px 10px rgba(20, 0, 100, 0.08);
      cursor: pointer;

      &:hover {
        top: -2px;
        box-shadow: 0px 4px 7px rgba(42, 35, 102, 0.2), 0px 3px 20px rgba(20, 0, 100, 0.08);
        cursor: pointer;
      }
    }
  }

  .summary-table {
    th {
      font-size: 0.9em;
    }
  }
</style>
